export default "__VITE_ASSET__ChvuvX1m__"